{
  "validation": "Échec de la validation",
  "forbidden": "Accès refusé",
  "unauthorized": "Non autorisé",
  "notFound": "Ressource introuvable",
  "duplicate": "La ressource existe déjà",
  "business": "Violation d'une règle métier",
  "internal": "Erreur interne du serveur",
  "tenant": "Accès inter-tenant refusé",
  "invalidToken": "Jeton invalide ou expiré",
  "subscriptionInactive": "Abonnement inactif",
  "planLimitExceeded": "Limite du forfait dépassée",
  "invalidCredentials": "E-mail ou mot de passe invalide",
  "networkError": "Erreur réseau. Veuillez réessayer.",
  "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter.",
  "saveFailed": "Échec de l'enregistrement",
  "updateFailed": "Échec de la mise à jour",
  "deleteFailed": "Échec de la suppression",
  "approvalFailed": "Échec de l'action d'approbation",
  "permissionDenied": "Permission refusée",
  "loadCompaniesFailed": "Échec du chargement des sociétés",
  "loadDisplaySettingsFailed": "Échec de l'enregistrement des paramètres d'affichage"
}
